import React from 'react';

import CustomWidgetRenderer from 'shared/components/WidgetRenderer';

interface WidgetProps {
  widgets: any[];
  pageName?: string;
  remainingInventoryIds?: string[];
  queryParamsObject?: object;
  pageData?: string;
  isPersonalized?: boolean;
}

const Widgets = ({
  widgets,
  pageName,
  remainingInventoryIds,
  queryParamsObject,
  pageData,
  isPersonalized = false,
}: WidgetProps) => {
  if (!(widgets && Array.isArray(widgets) && widgets.length > 0)) {
    return null;
  }
  return (
    <>
      {
        <CustomWidgetRenderer
          pageName={pageName}
          widgetList={widgets}
          isServer={__SERVER__}
          eagerLoadImages={1}
          allWidgetsLength={widgets.length}
          remainingInventoryIds={remainingInventoryIds}
          queryParamsObject={queryParamsObject}
          pageData={pageData}
          personalizationEnabled={isPersonalized}
        />
      }
    </>
  );
};

export default Widgets;
